import { Box } from '@montugroup/design-system';
import { Grid2, Skeleton } from '@mui/material';

export default function ProfileFormLoadingSkeleton() {
  return (
    <Box sx={{ mt: 6 }}>
      <Grid2 container rowSpacing={4} columnSpacing={7}>
        <Grid2 size={{ xs: 12, sm: 4 }}>
          <Skeleton variant="rectangular" width="100%" height={56} />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 4 }}>
          <Skeleton variant="rectangular" width="100%" height={56} />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 4 }}>
          <Skeleton variant="rectangular" width="100%" height={56} />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 8 }}>
          <Skeleton variant="rectangular" width="100%" height={56} />
        </Grid2>
      </Grid2>
    </Box>
  );
}
